import { useEffect } from "react";
import userPreferences from "../store/userPreferences";
import { useLocation } from "react-router-dom";

export default function useDarkMode() {
  const { isDarkMode, setIsDarkMode } = userPreferences();
  const location = window.location;

  const updateTheme = () => {
    var link = document.createElement("meta");
    link.setAttribute("name", "theme-color");
    const isLogin = location.pathname === "/";
    if (isDarkMode) {
      if (isLogin) {
        // link.content = "#00d3f2";
      } else {
      }
      link.content = "#111827";
    } else {
      if (isLogin) {
        // link.content = "#dbeafe";
      } else {
      }
      link.content = "#1e3a8a";
    }

    const prev = document?.querySelectorAll?.('meta[name="theme-color"]');

    if (prev?.length) {
      prev?.forEach((el: any) => {
        el?.remove?.();
      });
    }
    document?.getElementsByTagName?.("head")[0].appendChild(link);
  };

  useEffect(() => {
    document.body.classList.toggle("dark", isDarkMode);
    if (!isDarkMode) {
      localStorage?.removeItem?.("theme");
    } else {
      localStorage?.setItem?.("theme", "dark");
    }
    updateTheme();
  }, [isDarkMode, location]);

  return {
    isEnabled: isDarkMode,
    setEnabled: setIsDarkMode,
    updateTheme,
  };
}
